import React from 'react';
import PropTypes from 'prop-types';
import { config as piercingAppointmentIds } from '~/ocab-services/piercing/config/redirections.config.js';

const withDynamicDestroyOnUnmount = (WrappedComponent) => {
  class WithDynamicDestroyOnUnmount extends React.Component {
    componentWillUnmount() {
      const { shouldDestroyFormOnUnmount, dispatchFormDestroyOnUnmount } = this.props;

      if (shouldDestroyFormOnUnmount) {
        dispatchFormDestroyOnUnmount(false);
      }
    }

    isPiercingSelectedService() {
      const { selectedAppointmentID } = this.props;
      const selectedId = JSON.parse(selectedAppointmentID);
      const { appointmentsIds = [] } = piercingAppointmentIds;

      return appointmentsIds.includes(selectedId);
    }

    render() {
      if (this.isPiercingSelectedService()) {
        return <WrappedComponent {...this.props} destroyOnUnmount />;
      }

      return <WrappedComponent {...this.props} destroyOnUnmount={false} />;
    }
  }

  WithDynamicDestroyOnUnmount.propTypes = {
    shouldDestroyFormOnUnmount: PropTypes.bool.isRequired,
    selectedAppointmentID: PropTypes.string.isRequired,
    dispatchFormDestroyOnUnmount: PropTypes.func.isRequired,
  };

  return WithDynamicDestroyOnUnmount;
};

export default withDynamicDestroyOnUnmount;
